import { brand } from '@parsina/framework/ui/lib/brand';

import logo from 'url:../assets/logo.png';
import logoWhite from 'url:../assets/logo-white.png';
import logoCircle from 'url:../assets/parsina-logo-circle.png';
import posterTemplate from 'url:../assets/poster-template.jpg';
import proxiaLogo from 'url:../../brand-packs/proxia/logo.png';
import proxiaLogoWhite from 'url:../../brand-packs/proxia/logo-white.png';
import proxiaLogoCircle from 'url:../../brand-packs/proxia/logo-circle.png';

// ─────────────────────────────────────────────────────────────────────────────
// The panel's own images, chosen by the brand's `assetPack`
// (docs/rebranding/CONTRACT.md §2).
//
//   logo            the gradient mark — the session-error card
//   logoWhite       the white mark on the brand gradient — the boot card
//   logoCircle      the round mark in the middle of every printed QR code
//   posterTemplate  the A4 «پوستر معرفی مطب» background
//
// No pack: today's bundled Parsina images, exactly as before. A pack this build
// carries (its files live in brand-packs/<pack>/, the same folder the image
// bakes and docker-entrypoint.sh serves at /brand/ for the favicon, icons and
// manifest): that pack's images. An image the pack does NOT carry is `null`,
// never Parsina's — Parsina's poster template has «پارسینا» painted into it,
// and a pack exists precisely so nothing of Parsina's shows. Callers hide what
// comes back null.
// ─────────────────────────────────────────────────────────────────────────────

const PARSINA = Object.freeze({ logo, logoWhite, logoCircle, posterTemplate });

const PACKS = Object.freeze({
  proxia: Object.freeze({
    logo: proxiaLogo,
    logoWhite: proxiaLogoWhite,
    logoCircle: proxiaLogoCircle,
    // No poster: Parsina's is a Persian raster with its wordmark baked in, and
    // Proxia has no template yet — the poster button is hidden under it.
    posterTemplate: null,
  }),
});

/** The pack in force, or null for today's images (none named, or one this build lacks). */
function activePack() {
  const id = brand().assetPack;
  return id && Object.prototype.hasOwnProperty.call(PACKS, id) ? PACKS[id] : null;
}

/**
 * The URL of one of the panel's images under the brand in force, or null when
 * the brand's pack has no such image.
 *
 * @param {'logo'|'logoWhite'|'logoCircle'|'posterTemplate'} name
 */
export function brandAsset(name) {
  const pack = activePack();
  if (!pack) return PARSINA[name] ?? null;
  return pack[name] ?? null;
}
